import { useState, useEffect } from "react";
import { Search, Plus, Edit, XCircle, Check, X } from "lucide-react";
function AccountingAllocationRules() {
  const [clients, setClients] = useState([]);
  const [jackets, setJackets] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedJacket, setSelectedJacket] = useState("");
  const [rules, setRules] = useState([
    {
      id: 1,
      clientId: "CLI-001",
      jacketNumber: "JKT-2026-001",
      invoiceCategory: "Storage",
      serviceCode: "PALLET_STORAGE",
      glCode: "41000",
      costCenter: "WDC",
      productCode: "30",
      department: "Warehouse",
      revenueCategory: "Storage Revenue",
      allocationPercent: 100,
      billingMonth: "March 2026",
      active: true
    },
    {
      id: 2,
      clientId: "CLI-001",
      jacketNumber: "JKT-2026-001",
      invoiceCategory: "Labor",
      serviceCode: "LABOR_HOURS",
      glCode: "42000",
      costCenter: "CAS",
      productCode: "35",
      department: "Operations",
      revenueCategory: "Labor Revenue",
      allocationPercent: 100,
      billingMonth: "March 2026",
      active: true
    },
    {
      id: 3,
      clientId: "CLI-002",
      jacketNumber: "JKT-2026-002",
      invoiceCategory: "Processing",
      serviceCode: "ORDER_PROCESSING",
      glCode: "43000",
      costCenter: "CAS",
      productCode: "40",
      department: "Operations",
      revenueCategory: "Processing Revenue",
      allocationPercent: 70,
      billingMonth: "March 2026",
      active: true
    },
    {
      id: 4,
      clientId: "CLI-002",
      jacketNumber: "JKT-2026-002",
      invoiceCategory: "Processing",
      serviceCode: "ORDER_PROCESSING",
      glCode: "43500",
      costCenter: "IT",
      productCode: "40",
      department: "Technology",
      revenueCategory: "Processing Revenue",
      allocationPercent: 30,
      billingMonth: "March 2026",
      active: true
    },
    {
      id: 5,
      clientId: "CLI-003",
      jacketNumber: "JKT-2026-003",
      invoiceCategory: "Hosting",
      serviceCode: "HOSTING_MONTHLY",
      glCode: "44000",
      costCenter: "IT",
      productCode: "45",
      department: "Technology",
      revenueCategory: "Hosting Revenue",
      allocationPercent: 100,
      billingMonth: "March 2026",
      active: true
    },
    {
      id: 6,
      clientId: "CLI-003",
      jacketNumber: "JKT-2026-003",
      invoiceCategory: "Shipping",
      serviceCode: "SHIPPING_FEE",
      glCode: "45000",
      costCenter: "LS",
      productCode: "50",
      department: "Logistics",
      revenueCategory: "Shipping Revenue",
      allocationPercent: 80,
      billingMonth: "March 2026",
      active: true
    },
    {
      id: 7,
      clientId: "CLI-003",
      jacketNumber: "JKT-2026-003",
      invoiceCategory: "Shipping",
      serviceCode: "SHIPPING_FEE",
      glCode: "45500",
      costCenter: "WDC",
      productCode: "50",
      department: "Warehouse",
      revenueCategory: "Shipping Revenue",
      allocationPercent: 20,
      billingMonth: "March 2026",
      active: true
    },
    {
      id: 8,
      clientId: "CLI-001",
      jacketNumber: "JKT-2026-001",
      invoiceCategory: "Storage",
      serviceCode: "PALLET_STORAGE",
      glCode: "41000",
      costCenter: "WDC",
      productCode: "30",
      department: "Warehouse",
      revenueCategory: "Storage Revenue",
      allocationPercent: 100,
      billingMonth: "February 2026",
      active: false
    }
  ]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("active");
  const [isAddingRule, setIsAddingRule] = useState(false);
  const [newRule, setNewRule] = useState({
    invoiceCategory: "",
    serviceCode: "",
    glCode: "",
    allocationPercent: "",
    billingMonth: "March 2026"
  });
  useEffect(() => {
    const savedClients = localStorage.getItem("clients");
    if (savedClients) {
      setClients(JSON.parse(savedClients));
    }
    const savedJackets = localStorage.getItem("jackets");
    if (savedJackets) {
      setJackets(JSON.parse(savedJackets));
    }
    const savedRules = localStorage.getItem("allocationRules");
    if (savedRules) {
      setRules(JSON.parse(savedRules));
    }
  }, []);
  useEffect(() => {
    if (rules.length > 0) {
      localStorage.setItem("allocationRules", JSON.stringify(rules));
    }
  }, [rules]);
  const filteredJacketsByClient = selectedClient ? jackets.filter((j) => {
    const client = clients.find((c) => c.code === selectedClient);
    return client && j.clientId === client.id;
  }) : [];
  const deactivateRule = (id) => {
    setRules(rules.map(
      (rule) => rule.id === id ? { ...rule, active: false } : rule
    ));
  };
  const handleAddRule = () => {
    setIsAddingRule(true);
    setNewRule({
      invoiceCategory: "",
      serviceCode: "",
      glCode: "",
      allocationPercent: "",
      billingMonth: "March 2026"
    });
  };
  const handleSaveNewRule = () => {
    if (!newRule.invoiceCategory || !newRule.serviceCode || !newRule.glCode || !newRule.allocationPercent || !newRule.billingMonth) {
      alert("Please fill in all required fields");
      return;
    }
    if (!selectedClient || !selectedJacket) {
      alert("Please select a Client and Jacket before adding a rule");
      return;
    }
    const maxId = Math.max(...rules.map((r) => r.id), 0);
    const newRuleData = {
      id: maxId + 1,
      clientId: selectedClient,
      jacketNumber: selectedJacket,
      invoiceCategory: newRule.invoiceCategory,
      serviceCode: newRule.serviceCode,
      glCode: newRule.glCode,
      costCenter: "",
      productCode: "",
      department: "",
      // Can be added later if needed
      revenueCategory: "",
      // Can be added later if needed
      allocationPercent: parseFloat(newRule.allocationPercent),
      billingMonth: newRule.billingMonth,
      active: true
    };
    setRules([newRuleData, ...rules]);
    setIsAddingRule(false);
  };
  const handleCancelNewRule = () => {
    setIsAddingRule(false);
    setNewRule({
      invoiceCategory: "",
      serviceCode: "",
      glCode: "",
      allocationPercent: "",
      billingMonth: "March 2026"
    });
  };
  const handleNewRuleChange = (field, value) => {
    setNewRule((prev) => ({ ...prev, [field]: value }));
  };
  const filteredRules = rules.filter((rule) => {
    const matchesSearch = rule.serviceCode.toLowerCase().includes(searchTerm.toLowerCase()) || rule.glCode.includes(searchTerm) || rule.department.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === "all" ? true : filterStatus === "active" ? rule.active : !rule.active;
    const matchesClient = !selectedClient || rule.clientId === selectedClient;
    const matchesJacket = !selectedJacket || rule.jacketNumber === selectedJacket;
    return matchesSearch && matchesStatus && matchesClient && matchesJacket;
  });
  const groupedRules = filteredRules.reduce((acc, rule) => {
    if (!acc[rule.serviceCode]) {
      acc[rule.serviceCode] = [];
    }
    acc[rule.serviceCode].push(rule);
    return acc;
  }, {});
  return <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Accounting Allocation Rules
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Define revenue allocation rules for service codes
        </p>
      </div>

      {
    /* Client and Jacket Filters */
  }
      <div className="mb-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Client
            </label>
            <select
    value={selectedClient}
    onChange={(e) => {
      setSelectedClient(e.target.value);
      setSelectedJacket("");
    }}
    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  >
              <option value="">All Clients</option>
              {clients.map((client) => <option key={client.id} value={client.code}>
                  {client.name} ({client.code})
                </option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Jacket
            </label>
            <select
    value={selectedJacket}
    onChange={(e) => setSelectedJacket(e.target.value)}
    disabled={!selectedClient}
    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
  >
              <option value="">All Jackets</option>
              {filteredJacketsByClient.map((jacket) => <option key={jacket.id} value={jacket.jobNumber}>
                  {jacket.jobNumber} - {jacket.description1}
                </option>)}
            </select>
          </div>
        </div>
      </div>

      {
    /* Search and Actions */
  }
      <div className="mb-6 flex items-center justify-between">
        <div className="flex gap-4 flex-1">
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
    type="text"
    placeholder="Search by service code, GL code, or department..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  />
          </div>
          <select
    value={filterStatus}
    onChange={(e) => setFilterStatus(e.target.value)}
    className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  >
            <option value="all">All Rules</option>
            <option value="active">Active Only</option>
            <option value="inactive">Inactive Only</option>
          </select>
        </div>
        <button className="app-btn-gloss ml-4" onClick={handleAddRule}>
          <Plus className="w-5 h-5" />
          Add Allocation Rule
        </button>
      </div>

      {
    /* Allocation Rules Table */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Invoice Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Service Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  GL Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Allocation %
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Billing Month
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
              {
    /* New Rule Row */
  }
              {isAddingRule && <tr className="bg-green-50 dark:bg-green-950">
                  <td className="px-6 py-4 text-sm">
                    <input
    type="text"
    value={newRule.invoiceCategory}
    onChange={(e) => handleNewRuleChange("invoiceCategory", e.target.value)}
    placeholder="Invoice Category"
    className="w-full px-2 py-1 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 text-sm"
  />
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <input
    type="text"
    value={newRule.serviceCode}
    onChange={(e) => handleNewRuleChange("serviceCode", e.target.value)}
    placeholder="Service Code"
    className="w-full px-2 py-1 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 text-sm"
  />
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <input
    type="text"
    value={newRule.glCode}
    onChange={(e) => handleNewRuleChange("glCode", e.target.value)}
    placeholder="GL Code"
    className="w-full px-2 py-1 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 text-sm"
  />
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <input
    type="text"
    value={newRule.allocationPercent}
    onChange={(e) => handleNewRuleChange("allocationPercent", e.target.value)}
    placeholder="%"
    className="w-full px-2 py-1 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 text-sm"
  />
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <select
    value={newRule.billingMonth}
    onChange={(e) => handleNewRuleChange("billingMonth", e.target.value)}
    className="w-full px-2 py-1 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 text-sm"
  >
                      <option>January 2026</option>
                      <option>February 2026</option>
                      <option>March 2026</option>
                      <option>April 2026</option>
                      <option>May 2026</option>
                      <option>June 2026</option>
                      <option>July 2026</option>
                      <option>August 2026</option>
                      <option>September 2026</option>
                      <option>October 2026</option>
                      <option>November 2026</option>
                      <option>December 2026</option>
                    </select>
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <div className="flex items-center gap-2">
                      <button
    onClick={handleSaveNewRule}
    className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
    title="Save Rule"
  >
                        <Check className="w-4 h-4 text-green-600 dark:text-green-400" />
                      </button>
                      <button
    onClick={handleCancelNewRule}
    className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
    title="Cancel"
    aria-label="Cancel"
  >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>}
              
              {Object.entries(groupedRules).map(([serviceCode, serviceRules]) => serviceRules.map((rule, index) => {
    const isFirstInGroup = index === 0;
    const isMultipleAllocation = serviceRules.length > 1;
    const groupTotal = serviceRules.filter((r) => r.active).reduce((sum, r) => sum + r.allocationPercent, 0);
    const isLastInGroup = index === serviceRules.length - 1;
    return <tr
      key={rule.id}
      className={`hover:bg-gray-50 dark:hover:bg-gray-800 ${!rule.active ? "opacity-50 bg-gray-50 dark:bg-gray-800" : ""} ${isMultipleAllocation && rule.active ? "bg-blue-50 dark:bg-blue-950" : ""}`}
    >
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                        {isFirstInGroup && <div className="flex items-center gap-2">
                            {rule.invoiceCategory}
                            {isMultipleAllocation && <span className="px-2 py-0.5 bg-blue-600 text-white text-xs rounded">
                                Split
                              </span>}
                          </div>}
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                        {rule.serviceCode}
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                        {rule.glCode}
                      </td>
                      <td className="px-6 py-4 text-sm">
                        <div className="flex items-center gap-2">
                          <span className="font-medium text-gray-900 dark:text-gray-100">
                            {rule.allocationPercent}%
                          </span>
                          {isLastInGroup && isMultipleAllocation && <span className={`text-xs px-2 py-0.5 rounded ${groupTotal === 100 ? "bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200" : "bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200"}`}>
                              Total: {groupTotal}%
                            </span>}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                        {rule.billingMonth}
                      </td>
                      <td className="px-6 py-4 text-sm">
                        <div className="flex items-center gap-2">
                          <button
      className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
      title="Edit Rule"
    >
                            <Edit className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                          </button>
                          {rule.active && <button
      onClick={() => deactivateRule(rule.id)}
      className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
      title="Deactivate Rule"
    >
                              <XCircle className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                            </button>}
                        </div>
                      </td>
                    </tr>;
  }))}
            </tbody>
          </table>
        </div>
      </div>

      {
    /* Summary Info */
  }
      <div className="mt-4 flex items-center gap-6 text-sm text-gray-600 dark:text-gray-400">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded" />
          <span>Split Allocation</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded" />
          <span>Inactive Rule</span>
        </div>
        <div className="text-gray-900 dark:text-gray-100 font-medium">
          Total Rules: {filteredRules.length} ({filteredRules.filter((r) => r.active).length} active)
        </div>
      </div>
    </div>;
}
export {
  AccountingAllocationRules
};
